// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_AtualizarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payments/accounts/atualizar/{id}
 *
 * Updates a subaccount's information and linked franchises.
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_AtualizarInput {
name?: string
email?: string
document?: string
document_type?: string
phone?: string
mobilePhone?: string
address?: unknown[]
addressNumber?: string
complement?: string
province?: string
postalCode?: string
config?: unknown[]
fiscal_config?: unknown[]
sandbox_mode?: boolean
api_key?: string
franchise_ids?: number[]
}

registerContract('SubaccountsFranchises_AtualizarInput', {
  name:          { type: 'string',  required: false },
  email:         { type: 'string',  required: false },
  document:      { type: 'string',  required: false },
  document_type: { type: 'string',  required: false },
  phone:         { type: 'string',  required: false },
  mobilePhone:   { type: 'string',  required: false },
  address:       { type: 'array',   required: false },
  addressNumber: { type: 'string',  required: false },
  complement:    { type: 'string',  required: false },
  province:      { type: 'string',  required: false },
  postalCode:    { type: 'string',  required: false },
  config:        { type: 'array',   required: false },
  fiscal_config: { type: 'array',   required: false },
  sandbox_mode:  { type: 'boolean', required: false },
  api_key:       { type: 'string',  required: false },
  franchise_ids: { type: 'array',   required: false },
})
